export default "__VITE_ASSET__BKZZSZHt__"